// extracted by mini-css-extract-plugin
export default {"LoginPage":"Login_LoginPage__B2V30","formtail":"Login_formtail__KMdrh","checked":"Login_checked__xY47o","bgs":"Login_bgs__wLR9A"};